import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { OrderShipmentRefundSummaryResponse } from '@web/shared/module/shop';
import { AdminOrderShipmentMethodResponse } from './admin-order-shipment-method.response';

@jsonObject
export class AdminOrderRefundDataShipmentResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(AdminOrderShipmentMethodResponse)
  public readonly method!: AdminOrderShipmentMethodResponse;

  @jsonMember(OrderShipmentRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderShipmentRefundSummaryResponse>;
}
